import { useContext, useEffect, useRef, useState } from "react";
import NewDashboard from "./NewDashboard";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Dashboards/Dashboards.css";
import { LoadShortDate } from "../../../../functions/LoadShortDate";
import { LoadShortTime } from "../../../../functions/LoadShortTime";
import ManageAssignedCustomers from "./ManageAssignedCustomers";
import { AppContext } from "../../../AppProvider";
import TenantAdministratorSideBar from "../../../sidebar_components/TenantAdministratorSideBar";
import NavigationBar from "../../../navigation_components/NavigationBar";
import { useNavigate } from "react-router-dom";
import { DashboardContext } from "./DashboardProvider";
import DeleteDashboard from "./DeleteDashboard";
const DashboardsTable = ({dashboardsCurrentPage,dashboardsPageLimit,setShowManageAssignedCustomersWindow,setShowDeleteDashboardWindow}) => {
    const {
        dashboardSummaries,
        setDashboardSummary,
        selectedTenantAdminProfile,
    } = useContext(DashboardContext);
    const {user} = useContext(AppContext);
    const [name,setName] = useState(null);
    const [selectedDashboard,setSelectedDashboard] = useState(null);
    const navigate = useNavigate();
    const extractAssignedCustomersString = (customers) =>{
        return customers.filter(c => c?.external?.name?.length > 0).map(c => c?.external?.name).join(', ');
    };
    if(!Array.isArray(dashboardSummaries) || dashboardSummaries.length === 0) return(
        <div className="tenant-administrator-loading-dashboards-mask">
            <div className="tenant-administrator-loading-dashboards-mask-spinner"></div>
            <p>Loading dashboards, please wait...</p>
        </div>
    );
    return(
        <div className="tenant-admin-dashboards-table-container">
            <table className="tenant-admin-dashboards-table">
                <thead>
                    <tr id="tenant-admin-dashboards-table-header-row">
                        <th style={{width:'20%'}}>Created time</th>
                        <th style={{width:'20%'}}>Title</th>
                        <th style={{width:'40%'}}>Assigned customers</th>
                        <th style={{width:'10%'}}></th>
                    </tr>
                </thead>
                <tbody>
                    {dashboardSummaries && dashboardSummaries.slice((((dashboardsCurrentPage - 1) * dashboardsPageLimit)),(dashboardsCurrentPage * dashboardsPageLimit)).map(dashboardSummary =>{
                        return(
                            <tr key={dashboardSummary.id} onClick={async() =>{
                                navigate(`/tenants/${selectedTenantAdminProfile.id}/dashboards/${dashboardSummary?.id}`);
                            }}>
                                <td>{LoadShortDate(dashboardSummary.dateCreated)} {LoadShortTime(dashboardSummary.timeCreated)}</td>
                                <td>{dashboardSummary.title}</td>
                                <td>
                                    {extractAssignedCustomersString(dashboardSummary.customers)}
                                </td>
                                <td>
                                    <div className="controls-container">
                                        <div onClick={async (e) => {
                                            e.stopPropagation();
                                            setDashboardSummary(dashboardSummary);
                                            setShowManageAssignedCustomersWindow(true);
                                        }}>
                                            <img 
                                                className="tenant-admin-dashboards-table-manage-assigned-customers-icon"
                                                src={process.env.PUBLIC_URL + '/images/user-icon.jpg'}
                                                alt="Manage assigned customers icon"
                                                title="Manage assigned customers"
                                            />
                                        </div>
                                        <div onClick={async (e) =>{
                                                e.stopPropagation();
                                                setDashboardSummary(dashboardSummary);
                                                setShowDeleteDashboardWindow(true);
                                            }}>
                                            <img
                                                className="tenant-admin-dashboards-table-delete-icon"
                                                src={process.env.PUBLIC_URL + '/images/delete-icon.png'}
                                                alt="Delete dashboard icon"
                                                title="Delete dashboard"
                                            />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            {name && <ManageAssignedCustomers access_token={user.access_token} dashboard={selectedDashboard} setDashboard={setSelectedDashboard}/>}
        </div>
    );
};
const Dashboards = () =>{
    const {user,logout} = useContext(AppContext);
    const {
        dashboardSummaries,setDashboardSummaries,
        selectedTenantAdminProfile,setSelectedTenantAdminProfile
    } = useContext(DashboardContext);
    const [dashboardsPageLimit,setDashboardsPageLimit] = useState(20);
    const [dashboardsCurrentPage,setDashboardsCurrentPage] = useState(1);
    const [dashboardsCount,setDashboardsCount] = useState(0);
    const [dashboardsFetched,setDashboardsFetched] = useState(false);
    const [dashboardsOrdered,setDashboardsOrdered] = useState(false);
    const [tenantAdminProfiles,setTenantAdminProfiles] = useState(null);
    const [tenantAdminProfilesFetched,setTenantAdminProfilesFetched] = useState(false);
    const [showNewDashboardWindow,setShowNewDashboardWindow] = useState(null);
    const [showManageAssignedCustomersWindow,setShowManageAssignedCustomersWindow] = useState(false);
    const [showDeleteDashboardWindow,setShowDeleteDashboardWindow] = useState(false);
    const logoutTimerRef = useRef(null);
    const navigate = useNavigate();
    const fetchServerProfiles = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/all/get`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(Number(response.status) === 401) logout();
            const responseData = await response.json();
            setTenantAdminProfiles(responseData);
        }
        catch(error){
            console.error(error);
        }
        setTenantAdminProfilesFetched(true);
    };
    const fetchDashboardsPage = async(page) =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/dashboards?page=${page}&limit=${dashboardsPageLimit}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                return responseData;
            }
            else if(Number(response.status) === 401) logout();
            else throw new Error(response.status);
        }
        catch(error){
            console.error('An error occurred when fetching dashboards:',error);
        }
        return [];
    };
    const fetchAndSetDashboards = async() =>{
        try{
            if(!selectedTenantAdminProfile) return;
            setDashboardSummaries([]);
            const localDashboardsCount = await fetchDashboardsCount();
            const totalPages = Math.ceil(localDashboardsCount / dashboardsPageLimit);
            let pagesLoaded = 0;
            if(!localDashboardsCount || localDashboardsCount <= 0){
                return;
            }
            for(let page = 1;page <= totalPages;page++){
                fetchDashboardsPage(page).then((pageData) =>{
                    if(pageData && Array.isArray(pageData)){
                        setDashboardSummaries(prev => Array.isArray(prev)? [...prev,...pageData]:[...pageData]);
                    }
                }).catch(error =>{
                    console.error(`Error loading page ${page}:`,error);
                }).finally(() =>{
                    pagesLoaded++;
                    if(pagesLoaded === totalPages){
                        setDashboardsFetched(true);
                        setDashboardsOrdered(false);
                    }
                })
            }
        }
        catch(error){
            console.log('An error occurred when fetching all dashboards: ',error);
        }
    };
    const fetchDashboardsCount = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/dashboards/count`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                return(isNaN(Number(responseData))? 0:Number(responseData));
            }
            else if(Number(response.status) === 401) logout();
            else throw new Error(response.status);
        }
        catch(error){
            console.error('An error occurred when fetching dashboards count: ',error);
        }
        return 0;
    };
    const getPagesAvailable = () => {
        return Math.ceil(dashboardSummaries?.length / dashboardsPageLimit);
    };
    useEffect(() =>{
        document.title = 'Blink IOT | Dashboards';
    },[]);
    useEffect(() =>{
        if(tenantAdminProfilesFetched) return;
        if(!user){
            logoutTimerRef.current = setTimeout(() =>{
                navigate('/');
                window.location.reload();
            },10);
            return;
        }
        else{
            if(logoutTimerRef.current){
                clearTimeout(logoutTimerRef.current);
                logoutTimerRef.current = null;
            }
        }
        fetchServerProfiles();
    },[user,tenantAdminProfilesFetched]);
    useEffect(() =>{
        if(!selectedTenantAdminProfile || dashboardsFetched) return;
        fetchAndSetDashboards();
        const updateDashboardCount = async () =>{setDashboardsCount(await fetchDashboardsCount());}
        updateDashboardCount();
    },[dashboardsFetched,selectedTenantAdminProfile]);
    useEffect(() =>{
        if(selectedTenantAdminProfile) return;
        if(Array.isArray(tenantAdminProfiles)){
            tenantAdminProfiles.forEach(profile =>{
                if(profile?.defaultProfile) setSelectedTenantAdminProfile(profile);
            });
        }
    },[tenantAdminProfiles]);
    useEffect(() =>{
        if(!dashboardsFetched || !dashboardSummaries || dashboardsOrdered) return;
        setDashboardSummaries([...dashboardSummaries].sort((a,b) => a?.title?.localeCompare(b?.title)));
        setDashboardsOrdered(true);
    },[dashboardSummaries,dashboardsOrdered]);
    return(
        <div className="tenant-admin-dashboards-page">
            <NavigationBar/>
            <div className="tenant-admin-dashboards-page-layout">
                <div>
                    <TenantAdministratorSideBar/>
                </div>
                <div className="tenant-admin-dashboards-parent-container">
                    <div className="tenant-admin-dashboards-container">
                        <div className="tenant-admin-dashboards-header-container">
                            <h2>Dashboards</h2>
                            <div className="tenant-admin-dashboards-header-controls">
                                <select
                                    className="tenant-admin-dashboards-server-url-select"
                                    onChange={(e) => {
                                        setSelectedTenantAdminProfile(tenantAdminProfiles.find(profile => profile.id === e.target.value));
                                        setDashboardsFetched(false);
                                    }}
                                    value={selectedTenantAdminProfile? selectedTenantAdminProfile?.id:'select'}
                                >
                                    <option value="select" disabled>Server url</option>
                                    {tenantAdminProfiles && tenantAdminProfiles.map((tenantAdminProfile,index) => (
                                        <option key={index} value={tenantAdminProfile?.id}>{tenantAdminProfile?.profileName}</option>
                                    ))}
                                </select>
                                <button className="tenant-admin-add-new-dashboard-button" onClick={() => {setShowNewDashboardWindow(true)}}>
                                    <img src={`${process.env.PUBLIC_URL}/images/add-icon.png`} alt="Add" />
                                </button>
                                <button className="tenant-admin-refresh-dashboards-button" onClick={() =>{}}>
                                    <img src={`${process.env.PUBLIC_URL}/images/refresh-icon.png`} alt="Refresh"/>
                                </button>
                            </div>
                        </div>
                        {<DashboardsTable
                            dashboardsCurrentPage={dashboardsCurrentPage}
                            dashboardsPageLimit={dashboardsPageLimit}
                            fetchDashboards={fetchAndSetDashboards}
                            setShowManageAssignedCustomersWindow={setShowManageAssignedCustomersWindow}
                            setShowDeleteDashboardWindow={setShowDeleteDashboardWindow}
                        />}
                        <div className="tenant-admin-dashboards-footer-container">
                            <div className="tenant-admin-dashboards-page-limit-container">
                                <p>Items per page:</p>
                                <div>
                                    <select value={dashboardsPageLimit} onChange={(e) => setDashboardsPageLimit(e.target.value)}>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={30}>30</option>
                                    </select>
                                </div>
                            </div>
                            <div className="tenant-admin-dashboards-page-info-container">
                                <p>
                                    {((dashboardsCurrentPage - 1) * dashboardsPageLimit) + 1} - {Math.min(dashboardsCurrentPage * dashboardsPageLimit,dashboardsCount)} of {dashboardsCount}
                                </p>
                            </div>
                            <div className="tenant-admin-dashboards-page-navigator-container">
                                <p
                                    className={`first-page ${dashboardsCurrentPage === 1? 'inactive':''}`}
                                    title="First page"
                                    onClick={() =>{
                                        if(dashboardsCurrentPage <= 1) return;
                                        setDashboardsCurrentPage(1);
                                    }}>&#9198;</p>
                                <p
                                    className={`previous-page ${dashboardsCurrentPage === 1? 'inactive':''}`}
                                    title="Previous page"
                                    onClick={() =>{
                                        if(dashboardsCurrentPage <= 1) return;
                                        setDashboardsCurrentPage(dashboardsCurrentPage - 1);
                                    }}>&#9664;</p>
                                <p
                                    className={`next-page ${dashboardsCurrentPage === getPagesAvailable()? 'inactive':''}`}
                                    title="Next page"
                                    onClick={() =>{
                                        if(dashboardsCurrentPage === getPagesAvailable()) return;
                                        setDashboardsCurrentPage(dashboardsCurrentPage + 1);
                                    }}>&#9654;</p>
                                <p
                                    className={`last-page ${dashboardsCurrentPage === getPagesAvailable()? 'inactive':''}`}
                                    title="Last page"
                                    onClick={() =>{
                                        if(dashboardsCurrentPage === getPagesAvailable()) return;
                                        setDashboardsCurrentPage(getPagesAvailable());
                                    }}>&#9197;</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {<NewDashboard
                showNewDashboardWindow={showNewDashboardWindow}
                setShowNewDashboardWindow={setShowNewDashboardWindow}
                access_token={user?.access_token}
                setDashboardsFetched={setDashboardsFetched}
            />}
            {<ManageAssignedCustomers
                showManageAssignedCustomersWindow={showManageAssignedCustomersWindow}
                setShowManageAssignedCustomersWindow={setShowManageAssignedCustomersWindow}
            />}
            {<DeleteDashboard
                showDeleteDashboardWindow={showDeleteDashboardWindow}
                setShowDeleteDashboardWindow={setShowDeleteDashboardWindow}
            />}
        </div>
    );
};
export default Dashboards;